export enum SplitPageError {
  INVALID_FILE = "INVALID_FILE",
  LOAD_FAILED = "LOAD_FAILED",
  EMPTY_DOCUMENT = "EMPTY_DOCUMENT",
  DECODE_FAILED = "DECODE_FAILED",
  PAGE_PROCESSING_FAILED = "PAGE_PROCESSING_FAILED",
  INVALID_DIMENSIONS = "INVALID_DIMENSIONS",
  ENCODING_FAILED = "ENCODING_FAILED",
  BLOB_CREATION_FAILED = "BLOB_CREATION_FAILED",
  UNSUPPORTED_FILE_FORMAT = "UNSUPPORTED_FILE_FORMAT",
  EXCEEDS_PAGE_LIMIT = "EXCEEDS_PAGE_LIMIT",
  INVALID_PAGE_RANGE = "INVALID_PAGE_RANGE",
  EXCEEDS_PAGE_LIMIT_SPLIT_BY_PAGES = "EXCEEDS_PAGE_LIMIT_SPLIT_BY_PAGES",
  NON_BLANK_PASSWORD_PDF_LOAD_FAILED = "NON_BLANK_PASSWORD_PDF_LOAD_FAILED",
}

export const splittableFileTypes = ["application/pdf", "image/tiff"];
